import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './burger.module.scss';

const cx = classNames.bind(styles);

const Burger = ({ className: additionalClassName, theme, isToggled, onClick }) => {
  const className = cx('wrapper', theme, { toggled: isToggled }, additionalClassName);

  return (
    <button className={className} type="button" onClick={onClick}>
      <span />
      <span />
      <span />
    </button>
  );
};

Burger.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(['primary', 'secondary']),
  isToggled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

Burger.defaultProps = {
  className: null,
  theme: 'primary',
};

export default Burger;
